import { render, staticRenderFns } from "./classifyList.vue?vue&type=template&id=19426e8a&scoped=true&"
import script from "./classifyList.vue?vue&type=script&lang=js&"
export * from "./classifyList.vue?vue&type=script&lang=js&"
import style0 from "./classifyList.vue?vue&type=style&index=0&id=19426e8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19426e8a",
  null
  
)

export default component.exports